$(function() {
    bsCustomFileInput.init();
    $('body').click(function(e) {

        if (e.target.type == 'submit' && !e.target.classList.contains('skip')){

            if (e.target.form){
                if (e.target.form.id){

                    $('#'+$(e.target.form).attr('id')).validate({

                        submitHandler: function(form) {
                            e.target.disabled = true;
                            //forcePace();
                            myHoldOn();
                            form.submit();
                        },
                        errorElement: 'span',
                        errorPlacement: function (error, element) {
                            error.addClass('invalid-feedback');
                            element.closest('.form-group').append(error);
                        },
                        highlight: function (element, errorClass, validClass) {
                            $(element).addClass('is-invalid');
                        },
                        unhighlight: function (element, errorClass, validClass) {
                            $(element).removeClass('is-invalid');
                        }
                    });


                }


                //e.target.form.submit();
            }
        }else{

            if (e.target.classList.contains('btn') && !e.target.classList.contains('skip') && !e.target.classList.contains('toggle-off') && !e.target.classList.contains('toggle-on') && !e.target.classList.contains('toggle-handle')){

                e.target.classList.add('disabled');

            }
        }
    });


});

jQuery.extend(jQuery.validator.messages, {
  required: "Este campo es obligatorio.",
  remote: "Por favor, rellena este campo.",
  email: "Por favor, escribe una dirección de correo válida",
  url: "Por favor, escribe una URL válida.",
  date: "Por favor, escribe una fecha válida.",
  dateISO: "Por favor, escribe una fecha (ISO) válida.",
  number: "Por favor, escribe un número entero válido.",
  digits: "Por favor, escribe sólo dígitos.",
  creditcard: "Por favor, escribe un número de tarjeta válido.",
  equalTo: "Por favor, escribe el mismo valor de nuevo.",
  accept: "Por favor, escribe un valor con una extensión aceptada.",
  maxlength: jQuery.validator.format("Por favor, no escribas más de {0} caracteres."),
  minlength: jQuery.validator.format("Por favor, no escribas menos de {0} caracteres."),
  rangelength: jQuery.validator.format("Por favor, escribe un valor entre {0} y {1} caracteres."),
  range: jQuery.validator.format("Por favor, escribe un valor entre {0} y {1}."),
  max: jQuery.validator.format("Por favor, escribe un valor menor o igual a {0}."),
  min: jQuery.validator.format("Por favor, escribe un valor mayor o igual a {0}.")
});



window.enableValidate = function (elementId){
  $("#"+elementId).validate({
    errorElement: 'span',
    errorPlacement: function (error, element) {
      error.addClass('invalid-feedback');
      element.closest('.form-group').append(error);
    },
    highlight: function (element, errorClass, validClass) {
      $(element).addClass('is-invalid');
    },
    unhighlight: function (element, errorClass, validClass) {
      $(element).removeClass('is-invalid');
    }

  });
}

// VALIDACIÓN DE RUT
function validaRut(rutCompleto){
  if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test( rutCompleto ))
  return false;
  var tmp 	= rutCompleto.split('-');
  var digv	= tmp[1];
  var rut 	= tmp[0];
  if ( digv == 'K' ) digv = 'k' ;
  return (validaDigito(rut) == digv );
}

function validaDigito(T){
  var M=0,S=1;
  for(;T;T=Math.floor(T/10))
  S=(S+T%10*(9-M++%6))%11;
  return S?S-1:'k';
}

window.genericWarningToForm = function (formId){
    Swal.fire({
    title: '¿Estás seguro de continuar?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Sí, continuar!',
    cancelButtonText: 'No'
    }).then((result) => {

        if (result.value) {
            document.getElementById(formId).submit();
        }
    })
}

$.validator.addMethod("checkRUT", function(value, element) {
  return validaRut(value);
});

window.genericSwal = function(url){
  return Swal.fire({
    title: '¿Estás seguro de realizar esta acción?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#28a745',
    cancelButtonColor: '#d33',
    cancelButtonText: 'Cancelar',
    confirmButtonText: 'Sí, continuar!'
  }).then((result) => {
    if (result.value) {
      location.href = url;
    }{
      $("a").removeClass('disabled');
      $(".btn").blur();
      return false;
    }
  });
}

window.myHoldOn = function (){
  HoldOn.open({
    theme:"sk-cube-grid"
  });
}

window.myHoldOnClose = function (){
  HoldOn.close();
}

window.forcePace = function (){
  //Pace.options.elements.selectors= ['.will-never-exist']
  //Pace.restart();
  myHoldOn();
}

window.stopPace = function (){
  //Pace.options.elements.selectors= ['.will-never-exist']
  //Pace.restart();
  HoldOn.close();
}

window.onbeforeunload = renderLoading;
function renderLoading()
{
  //Pace.stop()
  //Pace.bar.render();
  myHoldOn();
}

toastr.options = {
  "closeButton": false,
  "debug": false,
  "newestOnTop": true,
  "progressBar": true,
  "positionClass": "toast-top-right",
  "preventDuplicates": false,
  "onclick": null,
  "showDuration": "300",
  "hideDuration": "1000",
  "timeOut": "5000",
  "extendedTimeOut": "1000",
  "showEasing": "swing",
  "hideEasing": "linear",
  "showMethod": "fadeIn",
  "hideMethod": "fadeOut"
}

$(function () {

  $('.select2').select2({
    theme: 'bootstrap4',
    language: {
      // You can find all of the options in the language files provided in the
      // build. They all must be functions that return the string that should be
      // displayed.
      errorLoading: function () {
        return 'No se pudieron cargar los resultados';
      },
      inputTooLong: function (args) {
        var remainingChars = args.input.length - args.maximum;

        var message = 'Por favor, elimine ' + remainingChars + ' car';

        if (remainingChars == 1) {
          message += 'ácter';
        } else {
          message += 'acteres';
        }

        return message;
      },
      inputTooShort: function (args) {
        var remainingChars = args.minimum - args.input.length;

        var message = 'Por favor, introduzca ' + remainingChars + ' car';

        if (remainingChars == 1) {
          message += 'ácter';
        } else {
          message += 'acteres';
        }

        return message;
      },
      loadingMore: function () {
        return 'Cargando más resultados…';
      },
      maximumSelected: function (args) {
        var message = 'Sólo puede seleccionar ' + args.maximum + ' elemento';

        if (args.maximum != 1) {
          message += 's';
        }

        return message;
      },
      noResults: function () {
        return 'No se encontraron resultados';
      },
      searching: function () {
        return 'Buscando…';
      },
      removeAllItems: function () {
        return 'Eliminar todos los elementos';
      }
    }
  })

  $('.select2-no-search').select2({
    theme: 'bootstrap4',
    minimumResultsForSearch: Infinity,
    language: "es",
    language: {
      // You can find all of the options in the language files provided in the
      // build. They all must be functions that return the string that should be
      // displayed.
      errorLoading: function () {
        return 'No se pudieron cargar los resultados';
      },
      inputTooLong: function (args) {
        var remainingChars = args.input.length - args.maximum;

        var message = 'Por favor, elimine ' + remainingChars + ' car';

        if (remainingChars == 1) {
          message += 'ácter';
        } else {
          message += 'acteres';
        }

        return message;
      },
      inputTooShort: function (args) {
        var remainingChars = args.minimum - args.input.length;

        var message = 'Por favor, introduzca ' + remainingChars + ' car';

        if (remainingChars == 1) {
          message += 'ácter';
        } else {
          message += 'acteres';
        }

        return message;
      },
      loadingMore: function () {
        return 'Cargando más resultados…';
      },
      maximumSelected: function (args) {
        var message = 'Sólo puede seleccionar ' + args.maximum + ' elemento';

        if (args.maximum != 1) {
          message += 's';
        }

        return message;
      },
      noResults: function () {
        return 'No se encontraron resultados';
      },
      searching: function () {
        return 'Buscando…';
      },
      removeAllItems: function () {
        return 'Eliminar todos los elementos';
      }
    }
  })
});

